import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-encarregado',
  templateUrl: './dashboard-encarregado.component.html',
  styleUrls: ['./dashboard-encarregado.component.scss'],
})
export class DashboardEncarregadoComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
